module.exports = __webpack_public_path__ + "frontend/images/gold/bg/overlay@2.png?186a74b4a83af4f4a4409419a3a518fd";